/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';

	const newsTopRedirect = () => {
		const newsArea = $('.js-news-top');
		if(location.pathname === ('/news/' || '/news/index.html')) {
			var latestYear_length = $('.rt_latest_year').length;
			if(latestYear_length === 0) {
				var vD = new Date();
				var vYear = vD.getYear();
				var vYear4 = (vYear < 2000) ? vYear+1900 : vYear;
				location.href = '/news/' + vYear4 + '/';
			} else {
				var latestYear = $('.rt_latest_year');
				location.href = '/news/' + latestYear[0].textContent + '/';
			}
		} else {
			newsArea.addClass(a);
		}
	};

	const newsYearList = () => {
		if($('.js-news-yearList').length) {
			var year = $('.rt_latest_year').text();
			var oldyear = $('.rt_earliest_year').text();
			const directoryYear = location.pathname.split('/')[2];
			// optionを追加
			for(var i =year; i>=Number(oldyear); i--) {
				$('.js-news-yearList').append($('<option>').html(''+i+'').val(''+i+''));
			}
			// 見ている年をselected
			$('.js-news-yearList').val(directoryYear);

			// 選択した年に飛ばす
			$('.js-news-yearList').change(function(){
				location.href = location.pathname.replace(directoryYear, $(this).val());
			});
		}
	};

	const newsCurrent = () => {
		if($('.news-tabItem').length) {
			$('.news-tabItem').removeClass(a);

			for(var i=0; i<$('.news-tabItem').length; i++) {
				if(location.pathname === $('.news-tabItem').eq(i).attr('href')) {
					$('.news-tabItem').eq(i).addClass(a);
				}
			}
			$('.js-toggle-text').html($('.news-tabItem.is-active').text());
		}
	};

	newsTopRedirect();
	newsYearList();
	newsCurrent();
})(window.jQuery, window.FUNCTIONS);